import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { logout } from "../slices/admin/authSlice";
import Sidebar from "./sidebar";
import avatar1 from '../assets/images/avatar-1.jpg';

const Header = () => {
    const dispatch = useDispatch();
    const { admin } = useSelector((state) => state.adminauth);
    const location = useLocation();
    const currentPath = location.pathname.split('/').pop();

    const toggleMenu = () => {
        console.log('sdadda');
        // Get the main-wrapper element
        const mainWrapper = document.getElementById('main-wrapper');

        console.log(mainWrapper.classList);
        // Toggle the menu-toggle class
        if (mainWrapper.classList.contains('slide-nav')) {
            mainWrapper.classList.remove('slide-nav');
        } else {
            mainWrapper.classList.add('slide-nav');
        }

    };


    const handleLogout = () => {
        dispatch(logout());
    }

    return (
        <>
            <header id="page-topbar">
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">
                            <div className="navbar-brand-box horizontal-logo">
                                <a href="index.html" className="logo logo-dark">
                                    {/* <span className="logo-sm">
                                        <h2 className="text-white mt-4">Point <span className="text-danger">of</span> Sale</h2>
                                       
                                    </span>
                                    <span className="logo-lg">
                                    <h2 className="text-white mt-4">Point <span className="text-danger">of</span> Sale</h2>
                                    </span> */}
                                    <img src="./logo.png" alt="Logo" className="logo-sm" />
                                </a>
                                <a href="index.html" className="logo logo-light">
                                    {/* <span className="logo-sm">
                                    <h2 className="text-white mt-4">Point <span className="text-danger">of</span> Sale</h2>
                                    </span>
                                    <span className="logo-lg">
                                    <h2 className="text-white mt-4">Point <span className="text-danger">of</span> Sale</h2>
                                    </span> */}
                                    <img src="./logo.png" alt="Logo" className="logo-sm" />
                                </a>
                            </div>
                            <button
                                onClick={() => toggleMenu()}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger material-shadow-none"
                                id="topnav-hamburger-icon"
                            >
                                <span className="hamburger-icon">
                                    <span />
                                    <span />
                                    <span />
                                </span>
                            </button>
                            {/* App Search*/}
                          
                        </div>
                        <div className="d-flex align-items-center">
                           
                            <div className="dropdown ms-sm-3 header-item topbar-user">
                                <button
                                    type="button"
                                    className="btn material-shadow-none"
                                    id="page-header-user-dropdown"
                                    data-bs-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <span className="d-flex align-items-center">
                                        <img
                                            className="rounded-circle header-profile-user"
                                            src={avatar1}
                                            alt="Header Avatar"
                                        />
                                        <span className="text-start ms-xl-2">
                                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                                                Admin
                                            </span>
                                            <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                                                Super Admin
                                            </span>
                                        </span>
                                    </span>
                                </button>
                                <div className="dropdown-menu dropdown-menu-end">
                                    {/* item*/}
                                    <h6 className="dropdown-header">Welcome Admin!</h6>
                                   
                                    <Link onClick={handleLogout} className="dropdown-item">
                                        <i className="mdi mdi-logout text-muted fs-16 align-middle me-1" />{" "}
                                        <span className="align-middle" data-key="t-logout">
                                            Logout
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div
                id="removeNotificationModal"
                className="modal fade zoomIn"
                tabIndex={-1}
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="NotificationModalbtn-close"
                            />
                        </div>
                        <div className="modal-body">
                            <div className="mt-2 text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/gsqxdxog.json"
                                    trigger="loop"
                                    colors="primary:#f7b84b,secondary:#f06548"
                                    style={{ width: 100, height: 100 }}
                                />
                                <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                                    <h4>Are you sure ?</h4>
                                    <p className="text-muted mx-4 mb-0">
                                        Are you sure you want to remove this Notification ?
                                    </p>
                                </div>
                            </div>
                            <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                                <button
                                    type="button"
                                    className="btn w-sm btn-light"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn w-sm btn-danger"
                                    id="delete-notification"
                                >
                                    Yes, Delete It!
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* /.modal-content */}
                </div>
                {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            {/* ========== App Menu ========== */}
            <div className="app-menu navbar-menu">
                {/* LOGO */}
                <div className="navbar-brand-box">
                    {/* Dark Logo*/}
                    <a href="index.html" className="logo logo-dark">
                        {/* <span className="logo-sm">
                        <h2 className="text-white mt-4">Point <span className="text-danger">of</span> Sale</h2>
                        </span>
                        <span className="logo-lg">
                        <h2 className="text-white mt-4">Point <span className="text-danger">of</span> Sale</h2>
                        </span> */}
                        <img src="./logo.png" alt="Logo" className="logo-sm" />
                    </a>
                    {/* Light Logo*/}
                    <a href="index.html" className="logo logo-light">
                        {/* <span className="logo-sm">
                        <h2 className="text-white mt-4">Point <span className="text-danger">of</span> Sale</h2>
                        </span>
                        <span className="logo-lg">
                        <h2 className="text-white mt-4">Point <span className="text-danger">of</span> Sale</h2>
                        </span> */}
                        <img src="./logo.png" alt="Logo" className="logo-sm" />
                    </a>
                    <button
                        type="button"
                        className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
                        id="vertical-hover"
                    >
                        <i className="ri-record-circle-line" />
                    </button>
                </div>
                <div className="dropdown sidebar-user m-1 rounded">
                    <button
                        type="button"
                        className="btn material-shadow-none"
                        id="page-header-user-dropdown"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <span className="d-flex align-items-center gap-2">
                            <img
                                className="rounded header-profile-user"
                                src={avatar1}
                                alt="Header Avatar"
                            />
                            <span className="text-start">
                                <span className="d-block fw-medium sidebar-user-name-text">
                                    Anna Adame
                                </span>
                                <span className="d-block fs-14 sidebar-user-name-sub-text">
                                    <i className="ri ri-circle-fill fs-10 text-success align-baseline" />{" "}
                                    <span className="align-middle">Online</span>
                                </span>
                            </span>
                        </span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-end">
                        {/* item*/}
                        <h6 className="dropdown-header">Welcome Anna!</h6>
                        <a className="dropdown-item" href="pages-profile.html">
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1" />{" "}
                            <span className="align-middle">Profile</span>
                        </a>
                        <a className="dropdown-item" href="apps-chat.html">
                            <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1" />{" "}
                            <span className="align-middle">Messages</span>
                        </a>
                        <a className="dropdown-item" href="apps-tasks-kanban.html">
                            <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1" />{" "}
                            <span className="align-middle">Taskboard</span>
                        </a>
                        <a className="dropdown-item" href="pages-faqs.html">
                            <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1" />{" "}
                            <span className="align-middle">Help</span>
                        </a>
                        <div className="dropdown-divider" />
                        <a className="dropdown-item" href="pages-profile.html">
                            <i className="mdi mdi-wallet text-muted fs-16 align-middle me-1" />{" "}
                            <span className="align-middle">
                                Balance : <b>$5971.67</b>
                            </span>
                        </a>
                        <a className="dropdown-item" href="pages-profile-settings.html">
                            <span className="badge bg-success-subtle text-success mt-1 float-end">
                                New
                            </span>
                            <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1" />{" "}
                            <span className="align-middle">Settings</span>
                        </a>
                        <a className="dropdown-item" href="auth-lockscreen-basic.html">
                            <i className="mdi mdi-lock text-muted fs-16 align-middle me-1" />{" "}
                            <span className="align-middle">Lock screen</span>
                        </a>
                        <a className="dropdown-item" href="auth-logout-basic.html">
                            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1" />{" "}
                            <span className="align-middle" data-key="t-logout">
                                Logout
                            </span>
                        </a>
                    </div>
                </div>
                <Sidebar/>
                <div className="sidebar-background" />
            </div>
            {/* Left Sidebar End */}
            {/* Vertical Overlay*/}
            <div className="vertical-overlay" />
        </>
    );
}

export default Header;